'use client';

import React from 'react';
import { ListSubheader, MenuItem } from '@mui/material';
import { getLocalTimezoneOption, getTimezoneOptionForCountry, resolveToDropdownTimezone, TIMEZONE_GROUPS } from '@/constants/timezones.constant';
export function TimezoneSelectMenuItems({
  jobCountry,
  extraOptions = []
}) {
  const local = getLocalTimezoneOption();
  const jobOption = getTimezoneOptionForCountry(jobCountry);
  // Avoid pinning the same zone twice when local matches job country.
  const showJobOption = Boolean(jobOption && jobOption.value !== local.value);
  const knownValues = new Set(TIMEZONE_GROUPS.flatMap(group => group.options.map(tz => tz.value)));
  knownValues.add(local.value);
  if (jobOption) knownValues.add(jobOption.value);
  const otherOptions = extraOptions.map(tz => ({
    ...tz,
    value: resolveToDropdownTimezone(tz.value)
  })).filter(tz => tz.value && !knownValues.has(tz.value));
  return <>
            <ListSubheader disableSticky>Suggested</ListSubheader>
            <MenuItem value={local.value}>{local.label}</MenuItem>

            {showJobOption && jobOption ? <MenuItem value={jobOption.value}>{jobOption.label}</MenuItem> : null}

            {TIMEZONE_GROUPS.map(group => <React.Fragment key={group.label}>
                    <ListSubheader disableSticky>{group.label}</ListSubheader>
                    {group.options.map(tz => <MenuItem key={`${group.label}-${tz.value}`} value={tz.value}>
                            {tz.label}
                        </MenuItem>)}
                </React.Fragment>)}

            {otherOptions.length > 0 && <>
                    <ListSubheader disableSticky>Other</ListSubheader>
                    {otherOptions.map(tz => <MenuItem key={`other-${tz.value}`} value={tz.value}>
                            {tz.label}
                        </MenuItem>)}
                </>}
        </>;
}